/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinginstagramdescription2Inputs */

const en_crosspostinginstagramdescription2 = /** @type {(inputs: Crosspostinginstagramdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create an Instagram post, reel, or story.`)
};

const de_crosspostinginstagramdescription2 = /** @type {(inputs: Crosspostinginstagramdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle einen Instagram-Beitrag, ein Reel oder eine Story.`)
};

/**
* | output |
* | --- |
* | "Create an Instagram post, reel, or story." |
*
* @param {Crosspostinginstagramdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinginstagramdescription2 = /** @type {((inputs?: Crosspostinginstagramdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinginstagramdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinginstagramdescription2(inputs)
	return de_crosspostinginstagramdescription2(inputs)
});
export { crosspostinginstagramdescription2 as "crosspostingInstagramDescription" }